import { render, staticRenderFns } from "./CardValues.vue?vue&type=template&id=7c853190&scoped=true"
import script from "./CardValues.vue?vue&type=script&lang=js"
export * from "./CardValues.vue?vue&type=script&lang=js"
import style0 from "./CardValues.vue?vue&type=style&index=0&id=7c853190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c853190",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
